import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(marketing)/faqs")({
	component: RouteComponent,
});

function RouteComponent() {
	return <div>Hello &quot;/(marketing)/faqs&quot;!</div>;
}
